import React from 'react'
import { GridColumn, Grid } from 'semantic-ui-react'

export const LeftPane = ({ children }) => (
  <GridColumn className="bg-white pt5 pb5" stretched>
    <Grid columns={1} container centered padded>
      <GridColumn className="onboarding-wizard-pane !justify-between">{children}</GridColumn>
    </Grid>
  </GridColumn>
)



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/pages/OnboardingWizard/LeftPane.js